import { translate } from '@teamleader/i18n';
import React from 'react';

import { TABS } from './Invoices';
import Counter from '../../../../Components/UI/Counter';
import Tabs, { Tab } from '../../../../Components/UI/Tabs';
import { Invoice } from '../../../../Types/invoice';

interface InvoiceTabsProps {
  invoice?: Invoice;
  fullWidth: boolean;
  handleOpenInvoices: () => void;
  handleOpenCreditNotes: () => void;
  activeTab: TABS;
}

const InvoiceTabs: React.FC<InvoiceTabsProps> = ({
  invoice,
  fullWidth,
  handleOpenInvoices,
  handleOpenCreditNotes,
  activeTab,
}) => {
  if (!invoice || invoice.creditNotes.length === 0) {
    return null;
  }

  return (
    <Tabs fullWidth={fullWidth}>
      <Tab onClick={handleOpenInvoices} selected={activeTab === TABS.INVOICE}>
        {translate('tabs.invoices', { amount: 1 })}
      </Tab>
      <Tab onClick={handleOpenCreditNotes} selected={activeTab === TABS.CREDIT_NOTES}>
        {translate('tabs.creditNotes', { amount: invoice.creditNotes.length })}
        <Counter
          marginLeft={3}
          count={invoice.creditNotes.length}
          theme={activeTab === TABS.CREDIT_NOTES ? 'primary' : 'neutral'}
        />
      </Tab>
    </Tabs>
  );
};

export default InvoiceTabs;
